import { GetTonePriceDto } from '../../../dto/gettoneprice/gettonepricedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetTonePriceRequest extends APIRequest
{
    getGetTonePriceRequest(): GetTonePriceDto;
}

export class GetTonePriceRequestImpl extends APIRequestDtoImpl implements GetTonePriceRequest
{
    constructor(private getTonePriceData: GetTonePriceDto)
    {
        super();
    }

    getGetTonePriceRequest(): GetTonePriceDto
    {
        return this.getTonePriceData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/gettuneprice/gettonepricerequest.tsx